export enum EmployeeStatusEnum {
  All = '',
  Archived = 'archived',
  Active = 'active',
}
